import {
  styled_default
} from "./chunk-ZLRFYDQA.js";

// src/index.ts
import { useCustomCells } from "@glideapps/glide-data-grid";

// src/cells/star-cell.tsx
import { GridCellKind } from "@glideapps/glide-data-grid";
import {
  createElement
} from "react";
var starPoints = [[50, 5], [61.23, 39.55], [97.55, 39.55], [68.16, 60.9], [79.39, 95.45], [50, 74.1], [20.61, 95.45], [31.84, 60.9], [2.45, 39.55], [38.77, 39.55]];
function pathStar(ctx, center, size) {
  let moved = false;
  for (const p of starPoints) {
    const x = (p[0] - 50) * (size / 100) + center[0];
    const y = (p[1] - 50) * (size / 100) + center[1];
    if (moved) {
      ctx.lineTo(x, y);
    } else {
      ctx.moveTo(x, y);
      moved = true;
    }
  }
  ctx.closePath();
}
var StarSVG = () => /* @__PURE__ */ createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ createElement("path", {
  d: "M47.1468 13.7811C48.0449 11.0172 51.9551 11.0172 52.8532 13.7812L60.5522 37.4762C60.9538 38.7123 62.1056 39.5491 63.4053 39.5491H88.3198C91.226 39.5491 92.4343 43.268 90.0831 44.9762L69.9269 59.6205C68.8755 60.3845 68.4355 61.7386 68.8371 62.9746L76.5361 86.6697C77.4342 89.4336 74.2707 91.732 71.9196 90.0238L51.7634 75.3794C50.7119 74.6155 49.2881 74.6155 48.2366 75.3795L28.0804 90.0238C25.7293 91.732 22.5659 89.4336 23.4639 86.6697L31.1629 62.9746C31.5645 61.7386 31.1245 60.3845 30.0731 59.6205L9.91686 44.9762C7.56572 43.268 8.77405 39.5491 11.6802 39.5491H36.5947C37.8944 39.5491 39.0462 38.7123 39.4478 37.4762L47.1468 13.7811Z",
  fill: "currentColor"
}));
var EditorWrap = /* @__PURE__ */ styled_default("div")({
  name: "EditorWrap",
  class: "e17a8fyf"
});
var renderer = {
  kind: GridCellKind.Custom,
  isMatch: (cell) => cell.data.kind === "star-cell",
  needsHover: true,
  draw: (args, cell) => {
    const {
      ctx,
      theme,
      rect,
      hoverAmount
    } = args;
    const {
      rating
    } = cell.data;
    const padX = theme.cellHorizontalPadding;
    let drawX = rect.x + padX;
    const stars = Math.min(5, Math.ceil(rating));
    drawX += 8;
    ctx.beginPath();
    for (let i = 0; i < stars; i++) {
      pathStar(ctx, [drawX, rect.y + rect.height / 2], 16);
      drawX += 18;
    }
    ctx.fillStyle = theme.textDark;
    ctx.globalAlpha = 0.6 + 0.4 * hoverAmount;
    ctx.fill();
    ctx.globalAlpha = 1;
    return true;
  },
  provideEditor: () => {
    return (p) => /* @__PURE__ */ createElement(EditorWrap, null, [0, 1, 2, 3, 4].map((index) => /* @__PURE__ */ createElement("div", {
      key: index,
      className: p.value.data.rating < index + 1 ? "inactive" : "active",
      onClick: () => {
        p.onChange({
          ...p.value,
          data: {
            ...p.value.data,
            rating: index + 1
          }
        });
      }
    }, /* @__PURE__ */ createElement(StarSVG, null))));
  },
  onPaste: (val, d) => {
    const num = Number.parseInt(val);
    return {
      ...d,
      rating: Number.isNaN(num) ? 0 : num
    };
  }
};
var star_cell_default = renderer;

// src/cells/sparkline-cell.tsx
import { parseToRgba, GridCellKind as GridCellKind2 } from "@glideapps/glide-data-grid";
var renderer2 = {
  kind: GridCellKind2.Custom,
  isMatch: (cell) => cell.data.kind === "sparkline-cell",
  needsHover: true,
  needsHoverPosition: true,
  draw: (args, cell) => {
    var _a;
    const { ctx, theme, rect, hoverAmount, hoverX } = args;
    let { values, yAxis, color, graphKind = "line", displayValues } = cell.data;
    const [minY, maxY] = yAxis;
    if (values.length === 0)
      return true;
    values = values.map((x) => Math.min(1, Math.max(0, (x - minY) / (maxY - minY))));
    const padX = theme.cellHorizontalPadding;
    const drawX = padX + rect.x;
    const y = rect.y + 3;
    const height = rect.height - 6;
    const width = rect.width - padX * 2;
    const delta = maxY - minY;
    const zeroY = maxY <= 0 ? y : minY >= 0 ? y + height : y + height * (maxY / delta);
    if (minY <= 0 && maxY >= 0) {
      ctx.beginPath();
      ctx.moveTo(drawX, zeroY);
      ctx.lineTo(drawX + width, zeroY);
      ctx.globalAlpha = 0.4;
      ctx.lineWidth = 1;
      ctx.strokeStyle = theme.textLight;
      ctx.stroke();
      ctx.globalAlpha = 1;
    }
    if (graphKind === "bar") {
      ctx.beginPath();
      const margin = 2;
      const spacing = (values.length - 1) * margin;
      const barWidth = (width - spacing) / values.length;
      let x = drawX;
      for (const val of values) {
        const barY = y + height - val * height;
        ctx.moveTo(x, zeroY);
        ctx.lineTo(x + barWidth, zeroY);
        ctx.lineTo(x + barWidth, barY);
        ctx.lineTo(x, barY);
        x += barWidth + margin;
      }
      ctx.fillStyle = (_a = cell.data.color) != null ? _a : theme.accentColor;
      ctx.fill();
    } else {
      if (values.length === 1)
        values = [values[0], values[0]];
      ctx.beginPath();
      const xStep = (rect.width - 16) / (values.length - 1);
      const points = values.map((val, ind) => {
        return {
          x: drawX + xStep * ind,
          y: y + height - val * height
        };
      });
      ctx.moveTo(points[0].x, points[0].y);
      let i;
      for (i = 1; i < points.length - 2; i++) {
        const xControl = (points[i].x + points[i + 1].x) / 2;
        const yControl = (points[i].y + points[i + 1].y) / 2;
        ctx.quadraticCurveTo(points[i].x, points[i].y, xControl, yControl);
      }
      ctx.quadraticCurveTo(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y);
      ctx.strokeStyle = color != null ? color : theme.accentColor;
      ctx.lineWidth = 1 + hoverAmount * 0.5;
      ctx.stroke();
      ctx.lineTo(rect.x + rect.width - padX, zeroY);
      ctx.lineTo(rect.x + padX, zeroY);
      ctx.closePath();
      ctx.globalAlpha = 0.2 + 0.2 * hoverAmount;
      const grad = ctx.createLinearGradient(0, y, 0, y + height * 1.4);
      grad.addColorStop(0, color != null ? color : theme.accentColor);
      const [r, g, b] = parseToRgba(color != null ? color : theme.accentColor);
      grad.addColorStop(1, `rgba(${r}, ${g}, ${b}, 0)`);
      ctx.fillStyle = grad;
      ctx.fill();
      ctx.globalAlpha = 1;
      if (hoverX !== void 0 && graphKind === "line" && displayValues !== void 0) {
        ctx.beginPath();
        const closest = Math.min(values.length - 1, Math.max(0, Math.round((hoverX - padX) / xStep)));
        ctx.moveTo(drawX + closest * xStep, rect.y);
        ctx.lineTo(drawX + closest * xStep, rect.y + rect.height);
        ctx.lineWidth = 1;
        ctx.strokeStyle = theme.textLight;
        ctx.stroke();
        ctx.save();
        ctx.font = `8px ${theme.fontFamily}`;
        ctx.fillStyle = theme.textMedium;
        ctx.textBaseline = "top";
        ctx.fillText(displayValues[closest], drawX, rect.y + theme.cellVerticalPadding);
        ctx.restore();
      }
    }
    return true;
  },
  provideEditor: () => void 0,
  onPaste: (_v, d) => d
};
var sparkline_cell_default = renderer2;

// src/cells/tags-cell.tsx
import { measureTextCached, getMiddleCenterBias, GridCellKind as GridCellKind3 } from "@glideapps/glide-data-grid";
import {
  createElement as createElement2
} from "react";

// src/draw-fns.ts
function roundedRect(ctx, x, y, width, height, radius) {
  if (radius === 0) {
    ctx.rect(x, y, width, height);
    return;
  }
  if (typeof radius === "number") {
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  }
  radius = {
    tl: Math.min(radius.tl, height / 2, width / 2),
    tr: Math.min(radius.tr, height / 2, width / 2),
    bl: Math.min(radius.bl, height / 2, width / 2),
    br: Math.min(radius.br, height / 2, width / 2)
  };
  ctx.moveTo(x + radius.tl, y);
  ctx.arcTo(x + width, y, x + width, y + radius.tr, radius.tr);
  ctx.arcTo(x + width, y + height, x + width - radius.br, y + height, radius.br);
  ctx.arcTo(x, y + height, x, y + height - radius.bl, radius.bl);
  ctx.arcTo(x, y, x + radius.tl, y, radius.tl);
}

// src/cells/tags-cell.tsx
var tagHeight = 20;
var innerPad = 6;
var _exp = () => (p) => p.tagHeight / 2;
var _exp2 = () => (p) => p.tagHeight;
var _exp3 = () => (p) => p.innerPad;
var EditorWrap2 = /* @__PURE__ */ styled_default("div")({
  name: "EditorWrap",
  class: "e43amum",
  vars: {
    "e43amum-0": [_exp(), "px"],
    "e43amum-1": [_exp2(), "px"],
    "e43amum-2": [_exp3(), "px"]
  }
});
var renderer3 = {
  kind: GridCellKind3.Custom,
  isMatch: (c) => c.data.kind === "tags-cell",
  draw: (args, cell) => {
    var _a, _b;
    const {
      ctx,
      theme,
      rect
    } = args;
    const {
      possibleTags,
      tags
    } = cell.data;
    const drawArea = {
      x: rect.x + theme.cellHorizontalPadding,
      y: rect.y + theme.cellVerticalPadding,
      width: rect.width - 2 * theme.cellHorizontalPadding,
      height: rect.height - 2 * theme.cellVerticalPadding
    };
    const rows = Math.max(1, Math.floor(drawArea.height / (tagHeight + innerPad)));
    let x = drawArea.x;
    let row = 1;
    let y = drawArea.y + (drawArea.height - rows * tagHeight - (rows - 1) * innerPad) / 2;
    for (const tag of tags) {
      const color = (_b = (_a = possibleTags.find((t) => t.tag === tag)) == null ? void 0 : _a.color) != null ? _b : theme.bgBubble;
      ctx.font = `12px ${theme.fontFamily}`;
      const metrics = measureTextCached(tag, ctx);
      const width = metrics.width + innerPad * 2;
      const textY = tagHeight / 2;
      if (x !== drawArea.x && x + width > drawArea.x + drawArea.width && row < rows) {
        row++;
        y += tagHeight + innerPad;
        x = drawArea.x;
      }
      ctx.fillStyle = color;
      ctx.beginPath();
      roundedRect(ctx, x, y, width, tagHeight, tagHeight / 2);
      ctx.fill();
      ctx.fillStyle = theme.textDark;
      ctx.fillText(tag, x + innerPad, y + textY + getMiddleCenterBias(ctx, `12px ${theme.fontFamily}`));
      x += width + 8;
      if (x > drawArea.x + drawArea.width && row >= rows)
        break;
    }
    return true;
  },
  provideEditor: () => {
    return (p) => {
      const {
        onChange,
        value
      } = p;
      const {
        possibleTags,
        tags,
        readonly = false
      } = value.data;
      return /* @__PURE__ */ createElement2(EditorWrap2, {
        tagHeight,
        innerPad,
        className: readonly ? "readonly" : ""
      }, possibleTags.map((t) => {
        const selected = tags.indexOf(t.tag) !== -1;
        return /* @__PURE__ */ createElement2("label", {
          key: t.tag
        }, !readonly && /* @__PURE__ */ createElement2("input", {
          className: "gdg-input",
          type: "checkbox",
          checked: selected,
          onChange: () => {
            const newTags = selected ? tags.filter((x) => x !== t.tag) : [...tags, t.tag];
            onChange({
              ...p.value,
              data: {
                ...value.data,
                tags: newTags
              }
            });
          }
        }), /* @__PURE__ */ createElement2("div", {
          className: "pill " + (selected ? "selected" : "unselected"),
          style: {
            backgroundColor: selected ? t.color : void 0
          }
        }, t.tag));
      }));
    };
  },
  onPaste: (v, d) => ({
    ...d,
    tags: d.possibleTags.map((x) => x.tag).filter((x) => v.split(",").map((s) => s.trim()).includes(x))
  })
};
var tags_cell_default = renderer3;

// src/cells/user-profile-cell.tsx
import {
  createElement as createElement3
} from "react";
import {
  measureTextCached as measureTextCached2,
  TextCellEntry,
  getMiddleCenterBias as getMiddleCenterBias2,
  GridCellKind as GridCellKind4
} from "@glideapps/glide-data-grid";
var renderer4 = {
  kind: GridCellKind4.Custom,
  isMatch: (cell) => cell.data.kind === "user-profile-cell",
  draw: (args, cell) => {
    const { ctx, rect, theme, imageLoader, col, row } = args;
    const { image, name, initial, tint } = cell.data;
    const xPad = theme.cellHorizontalPadding;
    const radius = Math.min(12, rect.height / 2 - theme.cellVerticalPadding);
    const drawX = rect.x + xPad;
    const imageResult = imageLoader.loadOrGetImage(image, col, row);
    ctx.save();
    ctx.beginPath();
    ctx.arc(drawX + radius, rect.y + rect.height / 2, radius, 0, Math.PI * 2);
    ctx.globalAlpha = 0.2;
    ctx.fillStyle = tint;
    ctx.fill();
    ctx.globalAlpha = 1;
    ctx.font = `600 16px ${theme.fontFamily}`;
    const metrics = measureTextCached2(initial[0], ctx);
    ctx.fillText(initial[0], drawX + radius - metrics.width / 2, rect.y + rect.height / 2 + getMiddleCenterBias2(ctx, `600 16px ${theme.fontFamily}`));
    if (imageResult !== void 0) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(drawX + radius, rect.y + rect.height / 2, radius, 0, Math.PI * 2);
      ctx.clip();
      ctx.drawImage(imageResult, drawX, rect.y + rect.height / 2 - radius, radius * 2, radius * 2);
      ctx.restore();
    }
    if (name !== void 0) {
      ctx.font = `${theme.baseFontStyle} ${theme.fontFamily}`;
      ctx.fillStyle = theme.textDark;
      ctx.fillText(name, drawX + radius * 2 + xPad, rect.y + rect.height / 2 + getMiddleCenterBias2(ctx, theme));
    }
    ctx.restore();
    return true;
  },
  provideEditor: () => (p) => {
    var _a;
    const { isHighlighted, onChange, value } = p;
    return /* @__PURE__ */ createElement3(TextCellEntry, {
      highlight: isHighlighted,
      autoFocus: true,
      value: (_a = value.data.name) != null ? _a : "",
      onChange: (e) => onChange({
        ...value,
        data: {
          ...value.data,
          name: e.target.value
        }
      })
    });
  },
  onPaste: (v, d) => ({
    ...d,
    name: v
  })
};
var user_profile_cell_default = renderer4;

// src/cells/dropdown-cell.tsx
import { getMiddleCenterBias as getMiddleCenterBias3, useTheme, GridCellKind as GridCellKind5 } from "@glideapps/glide-data-grid";
import {
  createElement as createElement4,
  useMemo,
  useState
} from "react";
import Select, { components } from "react-select";
var CustomMenu = (p) => {
  const {
    Menu
  } = components;
  const {
    children,
    ...rest
  } = p;
  return /* @__PURE__ */ createElement4(Menu, {
    ...rest
  }, children);
};
var Wrap = /* @__PURE__ */ styled_default("div")({
  name: "Wrap",
  class: "w13j932a"
});
var PortalWrap = /* @__PURE__ */ styled_default("div")({
  name: "PortalWrap",
  class: "p19663q2"
});
var Editor = (p) => {
  const {
    value: cell,
    onFinishedEditing,
    initialValue
  } = p;
  const {
    allowedValues,
    value: valueIn
  } = cell.data;
  const [value, setValue] = useState(valueIn);
  const [inputValue, setInputValue] = useState(initialValue != null ? initialValue : "");
  const theme = useTheme();
  const values = useMemo(() => allowedValues.map((x) => ({
    value: x,
    label: x
  })), [allowedValues]);
  return /* @__PURE__ */ createElement4(Wrap, null, /* @__PURE__ */ createElement4(Select, {
    className: "glide-select",
    inputValue,
    onInputChange: setInputValue,
    menuPlacement: "auto",
    value: values.find((x) => x.value === value),
    styles: {
      control: (base) => ({
        ...base,
        border: 0,
        boxShadow: "none"
      })
    },
    theme: (t) => {
      return {
        ...t,
        colors: {
          ...t.colors,
          neutral0: theme.bgCell,
          neutral5: theme.bgCell,
          neutral10: theme.bgCell,
          neutral20: theme.bgCellMedium,
          neutral30: theme.bgCellMedium,
          neutral40: theme.bgCellMedium,
          neutral50: theme.textLight,
          neutral60: theme.textMedium,
          neutral70: theme.textMedium,
          neutral80: theme.textDark,
          neutral90: theme.textDark,
          neutral100: theme.textDark,
          primary: theme.accentColor,
          primary75: theme.accentColor,
          primary50: theme.accentColor,
          primary25: theme.accentLight
        }
      };
    },
    menuPortalTarget: document.getElementById("portal"),
    autoFocus: true,
    openMenuOnFocus: true,
    components: {
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
      Menu: (props) => /* @__PURE__ */ createElement4(PortalWrap, null, /* @__PURE__ */ createElement4(CustomMenu, {
        className: "click-outside-ignore",
        ...props
      }))
    },
    options: values,
    onChange: async (e) => {
      if (e === null)
        return;
      setValue(e.value);
      await new Promise((r) => window.requestAnimationFrame(r));
      onFinishedEditing({
        ...cell,
        data: {
          ...cell.data,
          value: e.value
        }
      });
    }
  }));
};
var renderer5 = {
  kind: GridCellKind5.Custom,
  isMatch: (c) => c.data.kind === "dropdown-cell",
  draw: (args, cell) => {
    const {
      ctx,
      theme,
      rect
    } = args;
    const {
      value
    } = cell.data;
    ctx.fillStyle = theme.textDark;
    ctx.fillText(value, rect.x + theme.cellHorizontalPadding, rect.y + rect.height / 2 + getMiddleCenterBias3(ctx, theme));
    return true;
  },
  provideEditor: () => ({
    editor: Editor,
    disablePadding: true,
    deletedValue: (v) => ({
      ...v,
      copyData: "",
      data: {
        ...v.data,
        value: ""
      }
    })
  }),
  onPaste: (v, d) => ({
    ...d,
    value: d.allowedValues.includes(v) ? v : d.value
  })
};
var dropdown_cell_default = renderer5;

// src/cells/article-cell.tsx
import {
  Suspense,
  createElement as createElement5,
  lazy
} from "react";
import { getMiddleCenterBias as getMiddleCenterBias4, GridCellKind as GridCellKind6 } from "@glideapps/glide-data-grid";
var ArticleCellEditor = lazy(async () => await import("./article-cell-editor-GUJXT6WU.js"));
var renderer6 = {
  kind: GridCellKind6.Custom,
  isMatch: (c) => c.data.kind === "article-cell",
  draw: (args, cell) => {
    const { ctx, theme, rect } = args;
    const { markdown } = cell.data;
    let data = markdown;
    if (data.includes("\n")) {
      data = data.split(/\r?\n/)[0];
    }
    const max = rect.width / 4;
    if (data.length > max) {
      data = data.slice(0, max);
    }
    ctx.fillStyle = theme.textDark;
    ctx.fillText(data, rect.x + theme.cellHorizontalPadding, rect.y + rect.height / 2 + getMiddleCenterBias4(ctx, theme));
    return true;
  },
  provideEditor: () => ({
    editor: (p) => {
      return /* @__PURE__ */ createElement5(Suspense, {
        fallback: null
      }, /* @__PURE__ */ createElement5(ArticleCellEditor, {
        ...p
      }));
    },
    styleOverride: {
      position: "fixed",
      left: "12.5vw",
      top: "12.5vh",
      width: "75vw",
      borderRadius: "9px",
      maxWidth: "unset",
      maxHeight: "unset"
    },
    disablePadding: true
  }),
  onPaste: (val, d) => ({
    ...d,
    markdown: val
  })
};
var article_cell_default = renderer6;

// src/cells/range-cell.tsx
import {
  measureTextCached as measureTextCached3,
  getMiddleCenterBias as getMiddleCenterBias5,
  GridCellKind as GridCellKind7
} from "@glideapps/glide-data-grid";
import {
  createElement as createElement6
} from "react";
var RANGE_HEIGHT = 6;
var inputStyle = {
  marginRight: 8
};
var wrapperStyle = {
  display: "flex",
  alignItems: "center",
  flexGrow: 1
};
var renderer7 = {
  kind: GridCellKind7.Custom,
  isMatch: (c) => c.data.kind === "range-cell",
  draw: (args, cell) => {
    const { ctx, theme, rect } = args;
    const { min, max, value, label, measureLabel } = cell.data;
    const x = rect.x + theme.cellHorizontalPadding;
    const yMid = rect.y + rect.height / 2;
    const rangeSize = max - min;
    const fillRatio = (value - min) / rangeSize;
    ctx.save();
    let labelWidth = 0;
    if (label !== void 0) {
      ctx.font = `12px ${theme.fontFamily}`;
      labelWidth = measureTextCached3(measureLabel != null ? measureLabel : label, ctx, `12px ${theme.fontFamily}`).width + theme.cellHorizontalPadding;
    }
    const rangeWidth = rect.width - theme.cellHorizontalPadding * 2 - labelWidth;
    const gradient = ctx.createLinearGradient(x, yMid, x + rangeWidth, yMid);
    gradient.addColorStop(0, theme.accentColor);
    gradient.addColorStop(fillRatio, theme.accentColor);
    gradient.addColorStop(fillRatio, theme.bgBubble);
    gradient.addColorStop(1, theme.bgBubble);
    ctx.beginPath();
    ctx.fillStyle = gradient;
    roundedRect(ctx, x, yMid - RANGE_HEIGHT / 2, rangeWidth, RANGE_HEIGHT, RANGE_HEIGHT / 2);
    ctx.fill();
    ctx.beginPath();
    roundedRect(ctx, x + 0.5, yMid - RANGE_HEIGHT / 2 + 0.5, rangeWidth - 1, RANGE_HEIGHT - 1, (RANGE_HEIGHT - 1) / 2);
    ctx.strokeStyle = theme.accentLight;
    ctx.lineWidth = 1;
    ctx.stroke();
    if (label !== void 0) {
      ctx.textAlign = "right";
      ctx.fillStyle = theme.textDark;
      ctx.fillText(label, rect.x + rect.width - theme.cellHorizontalPadding, yMid + getMiddleCenterBias5(ctx, `12px ${theme.fontFamily}`));
    }
    ctx.restore();
    return true;
  },
  provideEditor: () => {
    return (p) => {
      const { data } = p.value;
      const strValue = data.value.toString();
      const strMin = data.min.toString();
      const strMax = data.max.toString();
      const strStep = data.step.toString();
      const onChange = (e) => {
        p.onChange({
          ...p.value,
          data: {
            ...data,
            value: Number(e.target.value)
          }
        });
      };
      return /* @__PURE__ */ createElement6("label", {
        style: wrapperStyle
      }, /* @__PURE__ */ createElement6("input", {
        style: inputStyle,
        type: "range",
        value: strValue,
        min: strMin,
        max: strMax,
        step: strStep,
        onChange
      }), strValue);
    };
  },
  onPaste: (v, d) => {
    let num = Number.parseFloat(v);
    num = Number.isNaN(num) ? d.value : Math.max(d.min, Math.min(d.max, num));
    return {
      ...d,
      value: num
    };
  }
};
var range_cell_default = renderer7;

// src/cells/spinner-cell.tsx
import { GridCellKind as GridCellKind8 } from "@glideapps/glide-data-grid";
var renderer8 = {
  kind: GridCellKind8.Custom,
  isMatch: (cell) => cell.data.kind === "spinner-cell",
  draw: (args) => {
    const { ctx, theme, rect, requestAnimationFrame } = args;
    const progress = window.performance.now() % 1e3 / 1e3;
    const x = rect.x + rect.width / 2;
    const y = rect.y + rect.height / 2;
    ctx.arc(x, y, Math.min(12, rect.height / 6), Math.PI * 2 * progress, Math.PI * 2 * progress + Math.PI * 1.5);
    ctx.strokeStyle = theme.textMedium;
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.lineWidth = 1;
    requestAnimationFrame();
    return true;
  },
  provideEditor: () => void 0
};
var spinner_cell_default = renderer8;

// src/cells/date-picker-cell.tsx
import {
  createElement as createElement7
} from "react";
import { drawTextCell, GridCellKind as GridCellKind9 } from "@glideapps/glide-data-grid";
var renderer9 = {
  kind: GridCellKind9.Custom,
  isMatch: (cell) => cell.data.kind === "date-picker-cell",
  draw: (args, cell) => {
    const { displayDate } = cell.data;
    drawTextCell(args, displayDate, cell.contentAlign);
    return true;
  },
  provideEditor: () => (p) => {
    const cellData = p.value.data;
    const { format, date } = cellData;
    let val = "";
    if (date !== void 0) {
      val = date.toISOString();
      if (format === "date") {
        val = val.split("T")[0];
      }
    }
    return /* @__PURE__ */ createElement7("input", {
      style: { minHeight: 26, border: "none", outline: "none" },
      type: format,
      autoFocus: true,
      value: val,
      onChange: (e) => {
        var _a;
        p.onChange({
          ...p.value,
          data: {
            ...p.value.data,
            date: (_a = e.target.valueAsDate) != null ? _a : void 0
          }
        });
      }
    });
  },
  onPaste: (v, d) => {
    let newDate;
    try {
      newDate = new Date(v);
    } catch (e) {
    }
    return {
      ...d,
      date: Number.isNaN(newDate) ? void 0 : newDate
    };
  }
};
var date_picker_cell_default = renderer9;

// src/cells/links-cell.tsx
import { measureTextCached as measureTextCached4, getMiddleCenterBias as getMiddleCenterBias6, GridCellKind as GridCellKind10, blend } from "@glideapps/glide-data-grid";
import {
  createElement as createElement8
} from "react";
function onClickSelect(e) {
  const useCtrl = e.cell.data.navigateOn !== "click";
  if (useCtrl !== e.ctrlKey)
    return void 0;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d", {
    alpha: false
  });
  if (ctx === null)
    return;
  const {
    posX: hoverX,
    bounds: rect,
    cell,
    theme
  } = e;
  const font = `${theme.baseFontStyle} ${theme.fontFamily}`;
  ctx.font = font;
  const {
    links
  } = cell.data;
  const xPad = theme.cellHorizontalPadding;
  let drawX = rect.x + xPad;
  const rectHoverX = rect.x + hoverX;
  for (const [index, l] of links.entries()) {
    const needsComma = index < links.length - 1;
    const metrics = measureTextCached4(l.title, ctx);
    const commaMetrics = needsComma ? measureTextCached4(l.title + ",", ctx, font) : metrics;
    const isHovered = rectHoverX > drawX && rectHoverX < drawX + metrics.width;
    if (isHovered) {
      return l;
    }
    drawX += commaMetrics.width + 4;
  }
  return void 0;
}
var renderer10 = {
  kind: GridCellKind10.Custom,
  needsHover: true,
  needsHoverPosition: true,
  isMatch: (c) => c.data.kind === "links-cell",
  onSelect: (e) => {
    if (onClickSelect(e) !== void 0) {
      e.preventDefault();
    }
  },
  onClick: (e) => {
    var _a;
    const hovered = onClickSelect(e);
    if (hovered !== void 0) {
      (_a = hovered.onClick) == null ? void 0 : _a.call(hovered);
      e.preventDefault();
    }
    return void 0;
  },
  draw: (args, cell) => {
    const {
      ctx,
      rect,
      theme,
      hoverX = -100,
      highlighted
    } = args;
    const {
      links,
      underlineOffset = 5
    } = cell.data;
    const xPad = theme.cellHorizontalPadding;
    let drawX = rect.x + xPad;
    const rectHoverX = rect.x + hoverX;
    const font = `${theme.baseFontStyle} ${theme.fontFamily}`;
    const middleCenterBias = getMiddleCenterBias6(ctx, font);
    const drawY = rect.y + rect.height / 2 + middleCenterBias;
    for (const [index, l] of links.entries()) {
      const needsComma = index < links.length - 1;
      const metrics = measureTextCached4(l.title, ctx, font);
      const commaMetrics = needsComma ? measureTextCached4(l.title + ",", ctx, font) : metrics;
      const isHovered = rectHoverX > drawX && rectHoverX < drawX + metrics.width;
      if (isHovered) {
        ctx.moveTo(drawX, Math.floor(drawY + underlineOffset) + 0.5);
        ctx.lineTo(drawX + metrics.width, Math.floor(drawY + underlineOffset) + 0.5);
        ctx.strokeStyle = theme.textDark;
        ctx.stroke();
        ctx.fillStyle = highlighted ? blend(theme.accentLight, theme.bgCell) : theme.bgCell;
        ctx.fillText(needsComma ? l.title + "," : l.title, drawX - 1, drawY);
        ctx.fillText(needsComma ? l.title + "," : l.title, drawX + 1, drawY);
        ctx.fillText(needsComma ? l.title + "," : l.title, drawX - 2, drawY);
        ctx.fillText(needsComma ? l.title + "," : l.title, drawX + 2, drawY);
      }
      ctx.fillStyle = theme.textDark;
      ctx.fillText(needsComma ? l.title + "," : l.title, drawX, drawY);
      drawX += commaMetrics.width + 4;
    }
    return true;
  },
  provideEditor: () => (p) => {
    const {
      value,
      onChange
    } = p;
    const {
      links,
      maxLinks = Number.MAX_SAFE_INTEGER
    } = value.data;
    return /* @__PURE__ */ createElement8(LinksCellEditorStyle, {
      onKeyDown: ignoreTab
    }, links.map((l, i) => {
      var _a;
      return /* @__PURE__ */ createElement8(LinkTitleEditor, {
        key: i,
        link: (_a = l.href) != null ? _a : "",
        title: l.title,
        focus: i === 0,
        onDelete: links.length > 1 ? () => {
          const newLinks = [...links];
          newLinks.splice(i, 1);
          onChange({
            ...value,
            data: {
              ...value.data,
              links: newLinks
            }
          });
        } : void 0,
        onChange: (link, title) => {
          const newLinks = [...links];
          newLinks[i] = {
            href: link,
            title
          };
          onChange({
            ...value,
            data: {
              ...value.data,
              links: newLinks
            }
          });
        }
      });
    }), /* @__PURE__ */ createElement8("button", {
      disabled: links.length >= maxLinks,
      className: "add-link",
      onClick: () => {
        const newLinks = [...links, {
          title: ""
        }];
        onChange({
          ...value,
          data: {
            ...value.data,
            links: newLinks
          }
        });
      }
    }, "Add link"));
  },
  onPaste: (v, d) => {
    const split = v.split(",");
    if (d.links.some((l, i) => split[i] !== l.title))
      return void 0;
    return {
      ...d,
      links: split.map((l) => ({
        title: l
      }))
    };
  }
};
var LinksCellEditorStyle = /* @__PURE__ */ styled_default("div")({
  name: "LinksCellEditorStyle",
  class: "lneeve5"
});
function ignoreTab(e) {
  if (e.key === "Tab") {
    e.stopPropagation();
  }
}
var LinkTitleEditor = (p) => {
  const {
    link,
    onChange,
    title,
    onDelete,
    focus
  } = p;
  return /* @__PURE__ */ createElement8("div", {
    className: "gdg-link-title-editor"
  }, /* @__PURE__ */ createElement8("input", {
    className: "gdg-title-input",
    value: title,
    placeholder: "Title",
    autoFocus: focus,
    onChange: (e) => {
      onChange(link, e.target.value);
    }
  }), /* @__PURE__ */ createElement8("input", {
    className: "gdg-link-input",
    value: link,
    placeholder: "URL",
    onChange: (e) => {
      onChange(e.target.value, title);
    }
  }), onDelete !== void 0 && /* @__PURE__ */ createElement8("button", {
    onClick: onDelete
  }, /* @__PURE__ */ createElement8("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "icon-import",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ createElement8("path", {
    d: "M3 6L5 6L21 6",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ createElement8("path", {
    d: "M17.9019 6C18.491 6 18.9525 6.50676 18.8975 7.09334L17.67 20.1867C17.5736 21.2144 16.711 22 15.6787 22H8.32127C7.28902 22 6.42635 21.2144 6.33 20.1867L5.1025 7.09334C5.04751 6.50676 5.50898 6 6.09813 6H17.9019Z",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ createElement8("path", {
    d: "M14.4499 10.211L13.9949 17",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ createElement8("path", {
    d: "M9.55499 10.211L10.0049 17",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ createElement8("path", {
    d: "M7.5 2.25H16.5",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var links_cell_default = renderer10;

// src/cells/button-cell.tsx
import {
  getMiddleCenterBias as getMiddleCenterBias7,
  GridCellKind as GridCellKind11,
  interpolateColors
} from "@glideapps/glide-data-grid";
function unpackColor(color, theme, hoverAmount) {
  if (typeof color === "string") {
    if (theme[color] !== void 0)
      return theme[color];
    return color;
  }
  let [normal, hover] = color;
  if (theme[normal] !== void 0)
    normal = theme[normal];
  if (theme[hover] !== void 0)
    hover = theme[hover];
  return interpolateColors(normal, hover, hoverAmount);
}
var renderer11 = {
  kind: GridCellKind11.Custom,
  isMatch: (c) => c.data.kind === "button-cell",
  needsHover: true,
  onSelect: (a) => a.preventDefault(),
  onClick: (a) => {
    var _a, _b;
    (_b = (_a = a.cell.data).onClick) == null ? void 0 : _b.call(_a);
    return void 0;
  },
  drawPrep: (args) => {
    const { ctx } = args;
    ctx.textAlign = "center";
    return {
      deprep: (a) => {
        a.ctx.textAlign = "start";
      }
    };
  },
  draw: (args, cell) => {
    const { ctx, theme, rect, hoverAmount } = args;
    const { title, backgroundColor, color, borderColor, borderRadius } = cell.data;
    const x = Math.floor(rect.x + theme.cellHorizontalPadding + 1);
    const y = Math.floor(rect.y + theme.cellVerticalPadding + 1);
    const width = Math.ceil(rect.width - theme.cellHorizontalPadding * 2 - 1);
    const height = Math.ceil(rect.height - theme.cellVerticalPadding * 2 - 1);
    if (backgroundColor !== void 0) {
      ctx.beginPath();
      roundedRect(ctx, x, y, width, height, borderRadius != null ? borderRadius : 0);
      ctx.fillStyle = unpackColor(backgroundColor, theme, hoverAmount);
      ctx.fill();
    }
    if (borderColor !== void 0) {
      ctx.beginPath();
      roundedRect(ctx, x + 0.5, y + 0.5, width - 1, height - 1, borderRadius != null ? borderRadius : 0);
      ctx.strokeStyle = unpackColor(borderColor, theme, hoverAmount);
      ctx.lineWidth = 1;
      ctx.stroke();
    }
    ctx.fillStyle = unpackColor(color != null ? color : theme.accentColor, theme, hoverAmount);
    ctx.fillText(title, x + width / 2, y + height / 2 + getMiddleCenterBias7(ctx, `${theme.baseFontStyle} ${theme.fontFamily}`));
    return true;
  },
  provideEditor: void 0
};
var button_cell_default = renderer11;

// src/index.ts
var cells = [
  star_cell_default,
  sparkline_cell_default,
  tags_cell_default,
  user_profile_cell_default,
  dropdown_cell_default,
  article_cell_default,
  spinner_cell_default,
  range_cell_default,
  date_picker_cell_default,
  links_cell_default,
  button_cell_default
];
function useExtraCells() {
  return useCustomCells(cells);
}
export {
  article_cell_default as ArticleCell,
  button_cell_default as ButtonCell,
  date_picker_cell_default as DatePickerCell,
  dropdown_cell_default as DropdownCell,
  links_cell_default as LinksCell,
  range_cell_default as RangeCell,
  sparkline_cell_default as SparklineCell,
  spinner_cell_default as SpinnerCell,
  star_cell_default as StarCell,
  tags_cell_default as TagsCell,
  user_profile_cell_default as UserProfileCell,
  cells as allCells,
  useExtraCells
};
